import { render } from "./BenefitsInfo.vue?vue&type=template&id=0316b886"
import script from "./BenefitsInfo.vue?vue&type=script&lang=js"
export * from "./BenefitsInfo.vue?vue&type=script&lang=js"

import "./BenefitsInfo.vue?vue&type=style&index=0&id=0316b886&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__